import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Typography, Tag, Popconfirm, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { updateBot } from '../../reducers/bots/resources';

const { Text } = Typography;

export default function GlobalErrors({ bot }) {
    const [errors, setErrors] = useState(bot?.global_errors || []);
    const [value, setValue] = useState('');

    useEffect(() => {
        setErrors(bot?.global_errors || []);
    }, [bot]);

    const persist = async (next) => {
        setErrors(next);
        if (bot?.id) await updateBot(bot.id, { global_errors: next });
    };

    const handleCreate = async () => {
        if (!value.trim()) return;
        const next = [...errors, { value: value.trim() }];
        await persist(next);
        setValue('');
    };

    const handleDelete = async (e) => {
        const next = errors.filter((x) => x.value !== e.value);
        await persist(next);
    };

    return (
        <div>
            {errors.length === 0 && (
                <Text type="secondary" style={{ display: 'block', fontSize: 12, margin: '4px 0' }}>
                    No global error phrases yet
                </Text>
            )}
            {errors.map((e, i) => (
                <div key={`${e.value}-${i}`} className="connection-row">
                    <Tag
                        color="red"
                        style={{
                            fontSize: 11,
                            flex: 1,
                            minWidth: 0,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        {e.value}
                    </Tag>
                    <Popconfirm
                        title="Delete this global error?"
                        onConfirm={() => handleDelete(e)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="text" danger size="small" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ))}
            <Divider style={{ margin: '8px 0' }} />
            <Space.Compact style={{ width: '100%' }}>
                <Input
                    placeholder="Error phrase"
                    value={value}
                    onChange={(ev) => setValue(ev.target.value)}
                    style={{ flex: 1 }}
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
                    Add
                </Button>
            </Space.Compact>
        </div>
    );
}
